import React from "react";
import BasePage from "../../../UI/BasePage/BasePage";
import Aux from "../../../hoc/Aux";
import {
  CardSection,
  Container,
} from "../../../UI/ContentSection/ContentSection";
//import styled from "styled-components";

import conceptImg from "../../../assests/images/concept.png";

// Content
import ConceptFiveSteps from "./Content/ConceptFiveSteps";
import ConceptCustomizable from "./Content/ConceptCustomizable";
import ConceptTrendsetter from "./Content/ConceptTrendsetter";
import ConceptPerfectFit from "./Content/ConceptPerfectFit";
//import ConceptDesign from "./Content/ConceptDesign";
import ConceptInnovation from "./Content/ConceptInnovation";

const Concept = () => {
  return (
    <Aux>
      <BasePage
        title={"CONCEPT"}
        image={conceptImg}
        textLineOne={"WE WANT TO PROVIDE AS MUCH STYLE FREEDOM AS POSSIBLE,"}
        textLineTwo={"FIRST STARTING WITH A HOODIE AND ADDING, STEP BY STEP,"}
        textLineThree={
          "MORE CLOTHES TYPES LIKE SHIRTS, PANTS, JACKETS, SNEAKERS ..."
        }
      />
      <CardSection>
        <Container>
          <ConceptFiveSteps />
          <ConceptCustomizable />
          <ConceptTrendsetter />
          <ConceptPerfectFit />
          <ConceptInnovation />
        </Container>
      </CardSection>
    </Aux>
  );
};

export default Concept;



// WEBPACK FOOTER //
// ./src/components/Pages/Concept/Concept.js